import { render, staticRenderFns } from "./FolderKebabMenu.vue?vue&type=template&id=80c39652&"
import script from "./FolderKebabMenu.vue?vue&type=script&lang=js&"
export * from "./FolderKebabMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports